import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@nrwl/common-lib';
import { Observable } from 'rxjs';

@Injectable()
export class CollectorApiService {
  private queryRunList = '/uicomm/GetRunList';
  private queryReport = '/uicomm/GetReport';
  private queryLastReport = '/uicomm/GetLastReport';
  private queryReportConfig = '/restconf/operations/viavi-report-query:queryReportConfig';
  private queryReportCount = '/uicomm/GetReportCount';
  private queryReportRuntime = '/restconf/operations/viavi-report-query:queryReport';
  private queryFilteredReport = '/uicomm/GetFilteredRtReport';

  constructor(private readonly apiService: ApiService, private readonly http: HttpClient) {}

  //eslint-disable-next-line
  getQueryRunList(id: number, isPublic = false): Observable<any> {
    const url = isPublic
      ? `/assurance/etherx/public${this.queryRunList}/${id}`
      : `${this.queryRunList}/${id}`;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(url, {});
  }

  //eslint-disable-next-line
  getQueryReport(
    id: number,
    type: string,
    runId?: number,
    maxresults?: number,
    isPublic = false
  ): Observable<any> {
    const url = isPublic ? '/assurance/etherx/public' + this.queryReport : this.queryReport;
    const params = {
      scheduleId: id,
      reportType: type,
      runid: runId,
      maxresults: maxresults
    };
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(url, params);
  }

  //eslint-disable-next-line
  getQueryLastReport(id: any, type: any, isPublic = false): Observable<any> {
    const url = isPublic ? `/assurance/etherx/public${this.queryLastReport}` : this.queryLastReport;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(url, {
      scheduleId: id,
      reportType: type
    });
  }

  //eslint-disable-next-line
  getQueryReportConfig(id: number): Observable<any> {
    const url = `${this.queryReportConfig}?scheduleid=${id}`;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(url, {});
  }

  //eslint-disable-next-line
  getQueryReportByFromTime(
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    id: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    runId: any,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    type: any,
    fromTime: string,
    maxResults?: number,
    reportFlows?: Array<any>,
    isPublic = false
  ): Observable<any> {
    const url = isPublic ? '/assurance/etherx/public' + this.queryReport : this.queryReport;
    const params = {
      scheduleId: id,
      reportType: type,
      runid: runId,
      reportFlows: reportFlows,
      fromtime: fromTime,
      maxresults: maxResults
    };
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(url, params);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getReportCount(opt: any, isPublic = false): Observable<any> {
    const url = isPublic
      ? `/assurance/etherx/public${this.queryReportCount}`
      : this.queryReportCount;
    return this.apiService.post$<any>(url, opt);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getReport(sheduleId: number, type: string, runId: number, runTime?: any): Observable<any> {
    let url = `${this.queryReportRuntime}/scheduleid=${sheduleId}/resulttype=${type}/runid=${runId}`;
    if (runTime) {
      url = `${this.queryReportRuntime}/scheduleid=${sheduleId}/resulttype=${type}/runtime=${runTime}`;
    }
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.get$<any>(url, {});
  }

  //eslint-disable-next-line
  getFilteredRtReport(opt: any): Observable<any> {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.apiService.post$<any>(this.queryFilteredReport, opt);
  }
}
